<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Sentiment Model Statistics
        </v-card-title>
        <v-tabs
        grow
        icons-and-text
        dark
        slider-color="grey lighten-4"
        color="primary"
        v-model="step">
          <v-tab ripple>
            Model Performance
          </v-tab>
          <v-tab ripple :disabled="isNew">
            Training History
          </v-tab>
        </v-tabs>
        <v-card-text>
          <v-tabs-items v-model="step">
            <v-tab-item class="mt-4">
              <v-layout row>
                <v-flex xs12>
                  <v-card>
                    <v-toolbar flat color="yellow darken-4" class="white--text">
                      <div class="headline">Accuracy Metrics</div>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-data-table
                    :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :headers="statisticsTableHeaders"
                    :items="accuracyMetrics">
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.class }}</td>
                        <td>{{ props.item.test_data_size }}</td>
                        <td>{{ props.item.precision | formatPercentage }}</td>
                        <td>{{ props.item.recall | formatPercentage }}</td>
                        <td>{{ props.item.f1_score | formatPercentage }}</td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item class="mt-4">
              <v-layout row>
                <v-flex xs12>
                  <v-card>
                    <v-toolbar flat color="yellow darken-4" class="white--text">
                      <div class="headline">Training History</div>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-data-table
                    :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :headers="trainingHistoryTableHeaders"
                    :items="trainingHistory">
                      <template slot="items" slot-scope="props">
                        <tr @click="props.expanded = !props.expanded">
                          <td>{{ props.item.annotation_work.name }}</td>
                          <td>{{ props.item.created_date | formatDate }}</td>
                          <td>{{ props.item.duration | formatDuration  }}</td>
                          <td>{{ props.item.data_size }}</td>
                          <td>{{ props.item.model_updated | formatBoolean }}</td>
                          <td>{{ props.item.performance.avg_f_score | formatPercentage }}</td>
                          <td class="text-xs-right">
                            <v-tooltip bottom color="success">
                              <v-icon
                                class="mr-2"
                                color="success"
                                slot="activator"
                                :disabled="!(props.item.performance)"
                                @click="performanceDetailDialog = true; performanceDetails = mapAccuracyMetrics(props.item.performance);"
                              >
                                insert_chart
                              </v-icon>
                              <span>Show Performance Detail</span>
                            </v-tooltip>
                            <v-tooltip bottom color="grey">
                              <v-icon
                                class="mr-2"
                                color="grey"
                                slot="activator"
                                @click="configDialog = true; configDetails = mapConfigs(props.item.model_configs)"
                              >
                                list_alt
                              </v-icon>
                              <span>Training Configs</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
    <v-dialog
    v-model="performanceDetailDialog"
    persistent
    scrollable
    width="1400"
    >
      <v-card>
        <v-card-title primary-title class="primary white--text headline">Performance Details</v-card-title>
          <v-data-table
          :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
          :headers="statisticsTableHeaders"
          :items="performanceDetails">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.class }}</td>
              <td>{{ props.item.test_data_size }}</td>
              <td>{{ props.item.precision | formatPercentage }}</td>
              <td>{{ props.item.recall | formatPercentage }}</td>
              <td>{{ props.item.f1_score | formatPercentage }}</td>
            </template>
          </v-data-table>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            @click="performanceDetails = []; performanceDetailDialog = false;"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
    v-model="configDialog"
    persistent
    scrollable
    width="1400"
    >
      <v-card>
        <v-card-title primary-title class="primary white--text headline">Model Configs</v-card-title>
          <v-data-table
          hide-actions
          :headers="experimentConfigTableHeaders"
          :items="configDetails">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.value }}</td>
            </template>
          </v-data-table>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            @click="configDetails = []; configDialog = false;"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    stepProp: {
      type: Number,
      required: false,
      default: 1
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
    }
    this.fetchSentimentModel()
  },
  data () {
    return {
      statisticsTableHeaders: [
        {text: 'Class', sortable: false, value: 'class'},
        {text: 'Test Data Size', sortable: false, value: 'test_data_size'},
        {text: 'Precision', sortable: false, value: 'precision'},
        {text: 'Recall', sortable: false, value: 'recall'},
        {text: 'F1 Score', sortable: false, value: 'f1_score'}
      ],
      trainingHistoryTableHeaders: [
        {text: 'Annotation Work', sortable: true, value: 'annotation_work'},
        {text: 'Created Date', sortable: true, value: 'created_date'},
        {text: 'Duration', sortable: true, value: 'duration'},
        {text: 'Training Data Size', sortable: true, value: 'data_size'},
        {text: 'Model Updated', sortable: true, value: 'model_updated'},
        {text: 'Test Data F1 Score', sortable: true, value: 'performance.avg_f_score'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      experimentConfigTableHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Value', sortable: false, value: 'value'}
      ],
      item: {
        id: '',
        language: '',
        name: '',
        dataset: '',
        topics: []
      },
      datasets: [],
      accuracyMetrics: [],
      trainingHistory: [],
      saveLoading: false,
      step: 0,
      performanceDetailDialog: false,
      performanceDetails: [],
      configDetails: [],
      topicListLoading: false
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
      topicModelTypes: state => state.configurations.topicModelTypesDictionary
    })
  },
  watch: {
    id (val) {
      this.item.id = val
    },
    stepProp (val) {
      this.step = val
    }
  },
  methods: {
    cancel () {
      this.$router.push('/sentiment-models/')
    },
    fetchSentimentModel () {
      this.axios.get(`/sentiment-models/${this.id}/stats`)
        .then(response => {
          this.accuracyMetrics = this.mapAccuracyMetrics(response.data.accuracy_metrics)
          this.trainingHistory = response.data.training_history
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    mapAccuracyMetrics (item) {
      var positive = {
        class: 'Positive',
        test_data_size: item.positive_label_sz,
        precision: item.positive_precision,
        recall: item.positive_recall,
        f1_score: item.positive_f_score
      }
      var neutral = {
        class: 'Neutral',
        test_data_size: item.neutral_label_sz,
        precision: item.neutral_precision,
        recall: item.neutral_recall,
        f1_score: item.neutral_f_score
      }
      var negative = {
        class: 'Negative',
        test_data_size: item.negative_label_sz,
        precision: item.negative_precision,
        recall: item.negative_recall,
        f1_score: item.negative_f_score
      }
      var average = {
        class: 'Average',
        test_data_size: '-',
        precision: item.avg_precision,
        recall: item.avg_recall,
        f1_score: item.avg_f_score
      }
      return [positive, neutral, negative, average]
    },
    mapConfigs (item) {
      console.log(item)
      var obj = JSON.parse(item)
      var res = [
        {name: 'Annotation Work ID', value: obj.annotation_work},
        {name: 'Minimum Positive Label Size', value: obj.min_positive_label_sz},
        {name: 'Minimum Neutral Label Size', value: obj.min_neutral_label_sz},
        {name: 'Minimum Negative Label Size', value: obj.min_negative_label_sz},
        {name: 'Positive F1 Threshold', value: '%' + (100 * obj.pos_f_score_threshold).toString()},
        {name: 'Neutral F1 Threshold', value: '%' + (100 * obj.neut_f_score_threshold).toString()},
        {name: 'Negative F1 Threshold', value: '%' + (100 * obj.neg_f_score_threshold).toString()},
        {name: 'Epoch Size', value: obj.epoch_size},
        {name: 'Learning Rate', value: obj.learning_rate},
        {name: 'Train All Layers', value: Vue.filter('formatBoolean')(obj.train_all_layers)}
      ]
      return res
    },
    ...mapActions({
      setLoader: 'loader/setLoader'
    })
  }
}
</script>

<style>

</style>
